import type { RiskReductionMeasureType } from '@/shared/hooks/api/machineryDirectiveCompliance'

export const RRM_HIERARCHY_TYPE_ORDER = [
  'ISD',
  'SCP',
  'OI',
  'PPE',
] as const satisfies readonly RiskReductionMeasureType[]

export type RrmHierarchyTypesWarning =
  | 'skippedIsdAndScp'
  | 'isdAfterLater'
  | 'scpAfterResidual'

export function getRrmHierarchyTypesWarning(
  selectedType: RiskReductionMeasureType | undefined,
  existingTypes: RiskReductionMeasureType[]
): RrmHierarchyTypesWarning | null {
  if (!selectedType) {
    return null
  }

  const hasIsd = existingTypes.includes('ISD')
  const hasScp = existingTypes.includes('SCP')
  const hasOi = existingTypes.includes('OI')
  const hasPpe = existingTypes.includes('PPE')

  if (
    (selectedType === 'OI' || selectedType === 'PPE') &&
    !hasIsd &&
    !hasScp
  ) {
    return 'skippedIsdAndScp'
  }

  if (selectedType === 'ISD' && (hasScp || hasOi || hasPpe)) {
    return 'isdAfterLater'
  }

  if (selectedType === 'SCP' && (hasOi || hasPpe)) {
    return 'scpAfterResidual'
  }

  return null
}

export function groupRiskReductionMeasuresByType<
  T extends { type: RiskReductionMeasureType },
>(measures: T[]): Map<RiskReductionMeasureType, T[]> {
  const grouped = new Map<RiskReductionMeasureType, T[]>()

  for (const type of RRM_HIERARCHY_TYPE_ORDER) {
    grouped.set(type, [])
  }

  for (const measure of measures) {
    grouped.get(measure.type)?.push(measure)
  }

  return grouped
}
